export default {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // Check if the click was outside the element and its children
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener("click", el.clickOutsideEvent)
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent)
  }
}
